import React from "react"
import { Helmet } from "react-helmet"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import List from "./List"
function ContactsList() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/contacts/list",
    },
    paths: [
      {
        label: "Contacts",
        link: "/contacts/list",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Conatcts List | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />

          <List />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ContactsList
